var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    class: {
      checkBox: true,
      disabled: _vm.isDisabled
    },
    attrs: {
      "aria-checked": _vm.checked || 'false',
      "aria-describedby": _vm.describedBy,
      "role": "checkbox",
      "tabindex": "10"
    },
    on: {
      "click": function () {
        return _vm.isDisabled ? _vm.onSelectDisabledCheckbox() : _vm.onSelect(_vm.id);
      },
      "keyup": function ($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return function () {
          return _vm.isDisabled ? _vm.onSelectDisabledCheckbox() : _vm.onSelect(_vm.id);
        }($event);
      }
    }
  }, [_c('span', {
    staticClass: "checkBoxIcon"
  }, [_vm.shouldShowX ? _c('WrongIcon') : _vm._e(), _vm.shouldShowCheck ? _c('CorrectIcon') : _vm._e(), _vm.checked && !_vm.shouldShowX && !_vm.shouldShowCheck ? _c('SelectedIcon') : _vm._e(), _vm.isHinted && !_vm.checked && !_vm.shouldShowX && !_vm.shouldShowCheck ? _c('div', {
    attrs: {
      "id": "hintBackground"
    }
  }) : _vm._e()], 1), _c('span', {
    class: _vm.labelClass,
    attrs: {
      "id": ("label-" + (_vm.id))
    }
  }, [_vm._v("\n    " + _vm._s(_vm.label) + "\n  ")])]);
}
var staticRenderFns = []

export { render, staticRenderFns }